export function validate(demoConfiguration) {
  const errors = {};

  validateCompanyName(demoConfiguration.companyName, errors);
  validateDemoDate(demoConfiguration.demoDate, errors);

  if (demoConfiguration.app === "dqi") {
    validateJobId(demoConfiguration.jobId, errors);
  }

  return { errors, valid: Object.keys(errors).length === 0 };
}

function validateCompanyName(name, errors) {
  if (isBlank(name)) {
    errors.companyName = "Company Name is required.";
  }
}

function validateDemoDate(date, errors) {
  if (isBlank(date)) {
    errors.demoDate = "Demo Date is required.";
  }
}

function validateJobId(jobId, errors) {
  if (isBlank(jobId)) {
    errors.jobId = "Job ID is required.";
  }
}

function isBlank(value) {
  return !value || value.trim().length === 0;
}
